import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.mitteilung-senden2';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenMitteilungSenden2Effects {

    MitteilungSenden2$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_MITTEILUNG_SENDEN2),
        mergeMap((x: ac.PostMitteilungSenden2Action) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postMitteilungSenden2(x.mitteilungenSendenRequest2).pipe(
                map((result: any) => {
                    return new ac.PostMitteilungSenden2ErfolgreichAction(result, x.mitteilungenSendenRequest2, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostMitteilungSenden2FehlerAction(error, x.mitteilungenSendenRequest2, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.MitteilungenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.MitteilungenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.MitteilungenCommandService);
        }
        return this.service;
    }
}
